import React from "react";
import HeaderStyle1 from "../components/layoutComponent/HeaderStyle/HeaderStyle1";
import SidebarStyle from "../components/layoutComponent/SidebarStyle/SidebarStyle";
import FooterStyle from "../components/layoutComponent/FooterStyle/FooterStyle";
// Router Component
import Layout1Route from "../router/landing-layout-route";
const Layout1 = () => {
  return (
    <>
      <div className="wrapper">
        <HeaderStyle1 />
        <SidebarStyle />
        <div className="content-page">
          <Layout1Route />
        </div>
      </div>
      <FooterStyle />
    </>
  );
};
export default Layout1;
